// Deutsche Texte – Standardsprache und Referenz für alle anderen Sprachen
// (Entscheidung 36). Neue Texte zuerst hier anlegen; en.ts muss denselben
// Aufbau haben, sonst schlägt der Typecheck fehl.
// Platzhalter in {{doppelten Klammern}} setzt i18next zur Laufzeit ein.
export const de = {
  app: {
    name: "Ortura",
    loading: "Wird geladen …",
    error: "Etwas ist schiefgelaufen.",
    retry: "Erneut versuchen",
    backToStart: "Zur Startseite",
  },
  start: {
    title: "Willkommen bei Ortura",
    subtitle: "Melden Sie sich an, um fortzufahren.",
    withGoogle: "Mit Google anmelden",
    withMicrosoft: "Mit Microsoft anmelden",
    otherMethods: "Andere Anmeldemethoden",
    noAccess: "Noch kein Zugang? Ihr Administrator schickt Ihnen einen Einladungslink.",
    devLogin: "Als Dev-Benutzer anmelden",
    devHint: "Lokaler Modus: Anmeldung mit Test-Token vom API-Dev-Server.",
  },
  callback: {
    working: "Anmeldung wird abgeschlossen …",
    failed: "Die Anmeldung ist fehlgeschlagen.",
  },
  select: {
    title: "Mandant wählen",
    subtitle: "Sie sind Mitglied in mehreren Mandanten.",
    create: "Neuen Mandanten anlegen",
  },
  onboarding: {
    title: "Mandanten anlegen",
    intro: "Legen Sie Ihren eigenen Mandanten an. Er startet als Testzugang.",
    name: "Name",
    namePlaceholder: "z. B. Muster GmbH",
    subdomain: "Kurzname für die Adresse",
    subdomainHelp:
      "Kleinbuchstaben, Ziffern und Bindestriche, 3 bis 32 Zeichen. Erscheint in der Adresse: …/t/{{subdomain}}",
    submit: "Mandanten anlegen",
    invalidName: "Bitte einen Namen mit 2 bis 100 Zeichen eingeben.",
    invalidSubdomain: "Nur Kleinbuchstaben, Ziffern und Bindestriche, 3 bis 32 Zeichen.",
  },
  invite: {
    working: "Einladung wird angenommen …",
    missingToken: "Der Einladungslink ist unvollständig.",
    failed: "Die Einladung konnte nicht angenommen werden.",
  },
  tenant: {
    notMember: "Kein Zugriff auf diesen Mandanten",
    notMemberHint: "Sie sind kein Mitglied dieses Mandanten oder er existiert nicht.",
    switch: "Mandant wechseln",
    status: { trial: "Testzugang", active: "Aktiv" },
  },
  nav: {
    overview: "Übersicht",
    members: "Mitglieder",
    logout: "Abmelden",
    signedInAs: "Angemeldet als {{email}}",
    language: "Sprache",
  },
  overview: {
    title: "Übersicht",
    welcome: "Willkommen im Mandanten {{name}}.",
    yourRole: "Ihre Rolle",
    placeholder: "Hier entstehen die Monitoring-Ansichten.",
  },
  members: {
    title: "Mitglieder",
    name: "Name",
    email: "E-Mail",
    role: "Rolle",
    joined: "Beigetreten",
    empty: "Noch keine Mitglieder.",
    inviteTitle: "Benutzer einladen",
    inviteIntro:
      "Erzeugt einen Einladungslink. Er ist 7 Tage gültig und kann einmal eingelöst werden. Geben Sie ihn selbst an die Person weiter.",
    inviteRole: "Rolle der eingeladenen Person",
    inviteSubmit: "Einladungslink erzeugen",
    inviteLink: "Einladungslink",
    copy: "Kopieren",
    copied: "Kopiert",
  },
  roles: {
    tenant_admin: "Administrator",
    operator: "Bediener",
    viewer: "Betrachter",
  },
  languages: { de: "Deutsch", en: "English" },
  // Fehlercodes der API (Feld error.code). Unbekannte Codes zeigen die
  // Meldung der API.
  errors: {
    unauthenticated: "Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.",
    forbidden: "Dafür fehlen Ihnen die Rechte.",
    not_a_member: "Kein Zugriff auf diesen Mandanten.",
    not_found: "Nicht gefunden.",
    conflict: "Das gibt es bereits.",
    limit_reached: "Das Limit ist erreicht.",
    invalid_input: "Die Eingabe ist ungültig.",
    network_error: "Der Server ist nicht erreichbar.",
  },
};

// Aufbau der Texte als Typ: gleiche Schlüssel, Werte beliebige Strings.
// (Ein "rekursiver Typ" – er wendet sich selbst auf verschachtelte Objekte an.)
type Shape<T> = { readonly [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
export type Translations = Shape<typeof de>;
